import { useEffect, useState } from "react";
import { useAuthStore } from "../../../auth/hooks";
import { useSelectFormStore, useForm, usePatientsStore } from "../../../hooks";
import { useFormMessages } from "../../hooks";
import { maritalStatuses, patientFormFieldsByIpsId } from "../../data";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  SuccessMessage,
  MainButton,
} from "../../ui";

export const AddPatientCard = () => {
  // Datos del hook ----------------------------------------//
  const {
    //props
    isLoading,
    message,

    //methods
    startRegisterPatient,
  } = usePatientsStore();

  const {
    //props
    user,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [formValidations, setFormValidations] = useState({});

  const {
    isLoading: isLoadingForm,
    documentTypes,
    countryPhones,
    genders,
    ratePlans,
    ethnicities,
  } = useSelectFormStore([
    "documentTypes",
    "countryPhones",
    "genders",
    "ratePlans",
    "ethnicities",
  ]);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
    onResetForm,
  });

  // Funciones ---------------------------------------------//
  const onRegister = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startRegisterPatient(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (user.ips.id) {
      const formfields =
        patientFormFieldsByIpsId[user.ips.id]?.fields ||
        patientFormFieldsByIpsId.default.fields;
      const formfValidations =
        patientFormFieldsByIpsId[user.ips.id]?.validations ||
        patientFormFieldsByIpsId.default.validations;

      // console.log("formfields", formfields);
      // console.log("formfValidations", formfValidations);

      if (Object.keys(formfields).length > 0) {
        setFormData(() => {
          const updated = {
            ...formfields,
            ipsId: user.ips.id,
          };
          return updated;
        });
        setFormValidations(() => {
          const updated = {
            ...formfValidations,
          };
          return updated;
        });
      }
    }
  }, [user]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  return (
    <div className="card border-0 rounded shadow">
      <div className="card-body">
        <form onSubmit={onRegister}>
          <div className="row gy-4">
            {/* Formulario estatico */}
            <>
              {"firstName" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Nombres"}
                    type={"text"}
                    validation={formValidation.firstNameValid}
                    submit={validateForm}
                    name={"firstName"}
                    value={formState.firstName}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"lastName" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Apellidos"}
                    type={"text"}
                    validation={formValidation.lastNameValid}
                    submit={validateForm}
                    name={"lastName"}
                    value={formState.lastName}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"documentTypeId" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Tipo de documento"}
                    options={documentTypes}
                    labelKey={"description"}
                    validation={formValidation.documentTypeIdValid}
                    submit={validateForm}
                    name={"documentTypeId"}
                    value={formState.documentTypeId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"document" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Documento"}
                    type={"text"}
                    validation={formValidation.documentValid}
                    submit={validateForm}
                    name={"document"}
                    value={formState.document}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"genderId" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Género"}
                    options={genders}
                    labelKey={"name"}
                    validation={formValidation.genderIdValid}
                    submit={validateForm}
                    name={"genderId"}
                    value={formState.genderId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"birthDate" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Fecha de nacimiento"}
                    type={"date"}
                    placeholder={"Fecha de nacimiento"}
                    validation={formValidation.birthDateValid}
                    submit={validateForm}
                    name={"birthDate"}
                    value={formState.birthDate}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"ratePlanId" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Plan de tarifa"}
                    options={ratePlans}
                    labelKey={"name"}
                    validation={formValidation.ratePlanIdValid}
                    submit={validateForm}
                    name={"ratePlanId"}
                    value={formState.ratePlanId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"ethnicityId" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Etnia"}
                    options={ethnicities}
                    labelKey={"name"}
                    validation={formValidation.ethnicityIdValid}
                    submit={validateForm}
                    name={"ethnicityId"}
                    value={formState.ethnicityId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"maritalStatus" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Estado civil"}
                    options={maritalStatuses}
                    labelKey={"name"}
                    validation={formValidation.maritalStatusValid}
                    submit={validateForm}
                    name={"maritalStatus"}
                    value={formState.maritalStatus}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"country" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Pais de residencia"}
                    type={"text"}
                    validation={formValidation.countryValid}
                    submit={validateForm}
                    name={"country"}
                    value={formState.country}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"department" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Departamento de residencia"}
                    type={"text"}
                    validation={formValidation.departmentValid}
                    submit={validateForm}
                    name={"department"}
                    value={formState.department}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"city" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Ciudad de residencia"}
                    type={"text"}
                    validation={formValidation.cityValid}
                    submit={validateForm}
                    name={"city"}
                    value={formState.city}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"address" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Dirección de residencia"}
                    type={"text"}
                    validation={formValidation.addressValid}
                    submit={validateForm}
                    name={"address"}
                    value={formState.address}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"birthCountry" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Pais de nacimiento"}
                    type={"text"}
                    validation={formValidation.birthCountryValid}
                    submit={validateForm}
                    name={"birthCountry"}
                    value={formState.birthCountry}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"birthDepartment" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Departamento de nacimiento"}
                    type={"text"}
                    validation={formValidation.birthDepartmentValid}
                    submit={validateForm}
                    name={"birthDepartment"}
                    value={formState.birthDepartment}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"birthCity" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"Ciudad de nacimiento"}
                    type={"text"}
                    validation={formValidation.birthCityValid}
                    submit={validateForm}
                    name={"birthCity"}
                    value={formState.birthCity}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              <div className="col-md-12">
                <hr className="flex-grow-1 m-0" />
              </div>
              {"countryPhoneId" in formState && (
                <div className="col-md-6">
                  <SelectForm
                    label={"Prefijo celular"}
                    options={countryPhones}
                    labelKey={"prefix"}
                    validation={formValidation.countryPhoneIdValid}
                    submit={validateForm}
                    name={"countryPhoneId"}
                    value={formState.countryPhoneId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"phoneNumber" in formState && (
                <div className="col-md-6">
                  <InputForm
                    label={"No. celular"}
                    type={"text"}
                    validation={formValidation.phoneNumberValid}
                    submit={validateForm}
                    name={"phoneNumber"}
                    value={formState.phoneNumber}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
              {"email" in formState && (
                <div className="col-md-12">
                  <InputForm
                    label={"Correo electrónico"}
                    sublabel={"(opcional)"}
                    type={"text"}
                    validation={formValidation.emailValid}
                    submit={validateForm}
                    name={"email"}
                    value={formState.email}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
            </>

            {Object.keys(formState).length > 0 && (
              <div className="col-md-12">
                <MainButton
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading || isLoadingForm}
                >
                  Agregar paciente
                </MainButton>
              </div>
            )}

            {/* Mensajes */}
            <>
              {(isLoading || isLoadingForm) && (
                <div className="col-md-12">
                  <LoadingData />
                </div>
              )}
              {showErrorMessage && (
                <div className="col-md-12">
                  <ErrorMessage>{messageText}</ErrorMessage>
                </div>
              )}
              {showSuccessMessage && (
                <div className="col-md-12">
                  <SuccessMessage>{messageText}</SuccessMessage>
                </div>
              )}
            </>
          </div>
        </form>
      </div>
    </div>
  );
};
